module.exports = __webpack_public_path__ + "static/media/Newsletter - January2022.1d6c34cc.pdf";